module.exports = __webpack_public_path__ + "static/media/pre-assesment-app-icn-1.ac75bd5b.png";